import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import DefaultButton from "@mostlycode/ui/dist/Button"
import { lighten } from "polished"

const StyledButton = styled(DefaultButton)`
  border: ${(props) => props.theme.buttonStyles[props.variant].border};
  letter-spacing: 0.1rem;
  transition: all ease-out 0.15s;
  border-radius: 5px;
  padding: 1rem;
  ${(props) => `
    background: ${props.theme.buttonStyles[props.variant].background};
    color: ${props.theme.buttonStyles[props.variant].color};
    border: ${props.theme.buttonStyles[props.variant].border};
  `}

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &:hover:not(:disabled) {
    ${(props) => `
      background: ${lighten(
        0.1,
        props.theme.buttonStyles[props.variant].background
      )};
      color: ${props.theme.buttonStyles[props.variant].color};
      border: 3px solid ${lighten(
        0.1,
        props.theme.buttonStyles[props.variant].hover.borderColor
      )};
    `}
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    padding: 1rem 2rem;
  `}
`

function Button({ children, variant, ...props }) {
  return (
    <StyledButton variant={variant} {...props}>
      {children}
    </StyledButton>
  )
}

export default Button

Button.defaultProps = {
  variant: "default",
}

Button.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "danger",
    "default",
    "transparent",
  ]),
  children: PropTypes.node.isRequired,
}
